import {gql} from "@irati/utils/gql"

const query = gql`
  query ActiveSessions($userId: String!) {
    loginActiveSessions(userId: $userId) {
      uuid
      userId
      userAgent
      createdAt
      refreshedAt
      isCurrent
    }
  }
`

export const toString = query.loc.source.body

export default query
